import { create } from 'zustand';

import { type MatchmakerMode } from '@services/AnalyticsService';

export const MATCHMAKER_MODE_STORAGE_KEY = 'mm_mode';

export const readStoredMatchmakerMode = (): MatchmakerMode => {
  try {
    return localStorage.getItem(MATCHMAKER_MODE_STORAGE_KEY) === 'matchmaker'
      ? 'matchmaker'
      : 'dating';
  } catch {
    return 'dating';
  }
};

const writeStoredMatchmakerMode = (mode: MatchmakerMode) => {
  try {
    localStorage.setItem(MATCHMAKER_MODE_STORAGE_KEY, mode);
  } catch {
    void 0;
  }
};

export type MatchmakerModeStore = {
  mode: MatchmakerMode;
  setMode: (mode: MatchmakerMode) => void;
};

/** The last «Знакомлюсь / Сваха» choice on this device; «Знакомлюсь» first. */
export const useMatchmakerModeStore = create<MatchmakerModeStore>()((set) => ({
  mode: readStoredMatchmakerMode(),
  setMode: (mode) => {
    writeStoredMatchmakerMode(mode);
    set({ mode });
  },
}));
